var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3388_12578)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 0H20.5V20H0.5V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71906 7.775C9.71906 7.305 10.1041 7.12 10.7441 7.12C11.6641 7.12 12.8241 7.4 13.7441 7.895V5.055C12.7391 4.655 11.7491 4.5 10.7491 4.5C8.29406 4.5 6.66406 5.78 6.66406 7.92C6.66406 11.255 11.2591 10.725 11.2591 12.165C11.2591 12.72 10.7741 12.9 10.0991 12.9C9.09406 12.9 7.81406 12.49 6.79906 11.935V14.81C7.92406 15.295 9.05906 15.5 10.0991 15.5C12.6141 15.5 14.3441 14.255 14.3441 12.09C14.3241 8.49 9.71906 9.13 9.71906 7.775Z",
    fill: "#635BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3388_12578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/Stripe.1441e885c44ce7cb1955affb4eb94099.svg";
export { ForwardRef as ReactComponent };